import { ParentBlock, Segment } from 'src/types/shared/blocksV3';
import BlockType from '../enums/blockType';
import { Block } from '../types/shared/blocksV3';

function getParentBlock(
	blocks: Block[],
	parentBlockData: ParentBlock
): { parentDeckBoxId: string; parentBlock: Block; parentSegment: Segment } {
	let parentDeckBoxId;
	let parentBlock;
	let parentSegment;

	switch (parentBlockData.type) {
		case BlockType.DECKBOX: {
			const deckboxes = blocks.filter((blk) => blk.type == BlockType.DECKBOX);
			const deckBox = deckboxes.find((dk) => dk.id == parentBlockData.id);

			parentSegment = deckBox?.edges
				.flatMap((edge) => edge.segments || [])
				.find((segment) => segment.id == parentBlockData.segmentId);
			parentDeckBoxId = deckBox?.id;
			parentBlock = deckBox;
			break;
		}
		case BlockType.LANDING: {
			const deckbox = blocks
				.filter((blk) => blk.type == BlockType.DECKBOX)
				.find((dk) =>
					dk.landings?.map((ld) => ld.id).includes(parentBlockData.id || '')
				);

			const landing = deckbox?.landings?.find(
				(ld) => ld.id == parentBlockData.id
			);

			parentSegment = landing?.edges
				.flatMap((edge) => edge.segments || [])
				.find((segment) => segment.id == parentBlockData.segmentId);
			parentDeckBoxId = deckbox?.id;
			parentBlock = landing;
			break;
		}
		case BlockType.STAIR: {
			const deckbox = blocks
				.filter((blk) => blk.type == BlockType.DECKBOX)
				.find((dk) =>
					dk.stairs?.map((st) => st.id).includes(parentBlockData.id || '')
				);

			const stair = deckbox?.stairs?.find((ld) => ld.id == parentBlockData.id);

			parentSegment = stair?.edges
				.flatMap((edge) => edge.segments || [])
				.find((segment) => segment.id == parentBlockData.segmentId);
			parentDeckBoxId = deckbox?.id;
			parentBlock = stair;
			break;
		}
		case BlockType.BUMPOUT: {
			const deckbox = blocks
				.filter((blk) => blk.type == BlockType.DECKBOX)
				.find((dk) =>
					dk.bumpouts?.map((bp) => bp.id).includes(parentBlockData.id || '')
				);

			const bumpout = deckbox?.bumpouts?.find(
				(bp) => bp.id == parentBlockData.id
			);

			parentSegment = bumpout?.edges
				.flatMap((edge) => edge.segments || [])
				.find((segment) => segment.id == parentBlockData.segmentId);
			parentDeckBoxId = deckbox?.id;
			parentBlock = bumpout;
			break;
		}
		default:
			break;
	}

	return { parentDeckBoxId, parentBlock, parentSegment };
}
export default getParentBlock;
